import React from 'react'
import Button from './button'
import useDiscussExperience from '../use-discuss-experience'

const MessageFacilitatorButton = ({ experience = {} }) => {
    const { showDiscussionConfiguration } = useDiscussExperience({ experience, users: [ experience.facilitatorId ] })
    return (
        <Button
            block
            size='lg'
            variant='outline-primary'
            onClick={() => showDiscussionConfiguration()}
        >
            MESSAGE INSTRUCTOR
        </Button>
    )
}

export default MessageFacilitatorButton